<template>
  <div v-show="!isDismissed" :class="[baseClass, typeClass]">
    <i v-if="icon" :class="`${baseClass}__icon material-icons`">{{ icon }}</i>
    <div class="flex-1 text-base">
      <slot></slot>
    </div>
    <trek-button v-if="isDismissible" text
      icon-only
      icon="close"
      :icon-success="type === 'sucess'"
      :icon-warning="type === 'warning'"
      :icon-alert="type === 'alert'"
      class="p-0"
      @click="dismiss"
    >
    </trek-button>
  </div>
</template>

<script>
import TrekButton from '@/components/TrekButton';

const ns = 'b2b-';
const name = 'callout';

export default {
  components: {TrekButton},
  props: {
    type: {
      type: String,
      default: 'success',
    },
    icon: {
      type: String,
      default: null,
    },
    isDismissible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isDismissed: false,
    };
  },
  computed: {
    baseClass() {
      return `${ns}${name}`;
    },
    typeClass() {
      return `${ns}${name}--${this.type}`;
    },
  },
  methods: {
    dismiss() {
      this.isDismissed = true;
      this.$emit('callback-dismissed');
    },
  },
};
</script>
